import { render, staticRenderFns } from "./editTabDokLoker.vue?vue&type=template&id=6f302096"
import script from "./editTabDokLoker.vue?vue&type=script&lang=js"
export * from "./editTabDokLoker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports